import ri from "./trigger-condition.js";
export default class ur {
  constructor(t) {
    (this.tf = t), (this.tf = t);
  }
  Jl(t) {
    return null == this.tf || ri.rf(t[0], this.tf);
  }
  static fromJson(t) {
    return new ur(t ? t.campaign_id : null);
  }
  Y() {
    return this.tf;
  }
}
